package feature.productCategory.event

class ProductCategoryEvent {
    companion object {
        const val CREATE = "CREATE_PRODUCT_CATEGORY"
        const val UPDATE = "UPDATE_PRODUCT_CATEGORY"
        const val UPDATE_IMAGE = "UPDATE_PRODUCT__CATEGORY_IMAGE"
        const val RETRIEVE = "RETRIEVE_PRODUCT_CATEGORY"
        const val DELETE = "DELETE_PRODUCT_CATEGORY"
    }

}